import React from "react";
import "../../Styles/certified/cmobile.css";

export default function Finzly() {
  return (
    <>
      <div className="cmobile-certified-details-section">
        <div className="cmobile-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="cmobile-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="cmobile-certified-details-left">
            <img
              src="/assets/cmobile/cmobile_ribbon.png"
              alt="Outstanding Workplaces Certified"
              className="cmobile-certified-badge"
            />
            <div className="cmobile-certified-company-names">
              <a href="https://www.cmtelematics.com/" target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/cmobile/cmobile_logo.png"
                alt="Walkzero Logo"
                className="cmobile-certified-company-logo"
              />
            </a>
              <h1 className="cmobile-certified-full-name">
               CMobile Telematics India Private Limited
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="cmobile-certified-details-right">
            <img
              src="/assets/cmobile/cmobile_6.jpg"
              alt="Finzly Office"
              className="cmobile-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="cmobile-certified-description">
          <h2>
            Why CMobile Telematics India Private Limited is an Outstanding Workplaces
          </h2>
          <p>
           CMobile Telematics India Private Limited is a technology-driven organisation and a subsidiary of Cambridge Mobile Telematics Inc., specialising in software development, telematics, and technology support services. The company contributes to innovative mobility and connected technology solutions through its expertise in data and software engineering.

          </p>
        </div>
        {/* Info Cards Section */}
        <div className="cmobile-certified-info-cards">
          <div className="cmobile-certified-info-card">
            <div className="cmobile-certified-info-title">COMPANY SIZE</div>
            <div className="cmobile-certified-info-value"> 57 Employees</div>
          </div>
          <div className="cmobile-certified-info-card">
            <div className="cmobile-certified-info-title">INDUSTRY</div>
            <div className="cmobile-certified-info-value">DeepTech, Technology, Telematics Frontier Labs

</div>
          </div>
          <div className="cmobile-certified-info-card">
            <div className="cmobile-certified-info-title">CONNECT</div>
            <div className="cmobile-certified-info-icons">
              <span className="cmobile-certified-icon-round">
                <a href="https://www.cmtelematics.com/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="cmobile-certified-icon-round">
                <a href="https://www.linkedin.com/company/cmt-ai/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              
            </div>
          </div>
          <div className="cmobile-certified-info-card">
            <div className="cmobile-certified-info-title">LOCATION (HQ)</div>
            <div className="cmobile-certified-info-value">Cambridge, MA</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="cmobile-certified-recognition-section">
          <h2 className="cmobile-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="cmobile-certified-recognition-badge">
            <img
              src="/assets/cmobile/cmobile_ribbon.png"
              alt="Outstanding Workplaces Certified"
              className="cmobile-certified-recognition-image"
            />
          </div>
          <div className="cmobile-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Finzly Section */}
        <div className="cmobile-certified-life-section">
          <h2 className="cmobile-certified-life-title">
            Life at CMobile Telematics India Private Limited
          </h2>
          <div className="cmobile-certified-life-gallery">
            <div className="cmobile-certified-life-col">
              <img src="/assets/cmobile/cmobile_1.jpg" alt="Office 1" className="cmobile-certified-life-img" />
              <img src="/assets/cmobile/cmobile_2.jpg" alt="Team 1" className="cmobile-certified-life-img" />
            </div>
            <div className="cmobile-certified-life-col cmobile-certified-life-center">
              <img src="/assets/cmobile/cmobile_3.jpg" alt="Main Office" className="cmobile-certified-life-img cmobile-certified-life-img-large" />
            </div>
            <div className="cmobile-certified-life-col">
              <img src="/assets/cmobile/cmobile_4.jpg" alt="Office 2" className="cmobile-certified-life-img" />
              <img src="/assets/cmobile/cmobile_5.jpg" alt="Team 2" className="cmobile-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
